import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';
import { LocationManagementPort, CreateLocationData, UpdateLocationData } from '../../domain/ports/LocationManagementPort';
import { RepositoryError } from '../../domain/errors';
import { ILoggerService } from '../../domain/services/LoggerService';

export class FirebaseLocationManagementAdapter implements LocationManagementPort {
  private readonly prefix = 'locations';
  private readonly logger: ILoggerService;

  constructor(logger: ILoggerService) {
    this.logger = logger;
  }

  async createLocation(data: CreateLocationData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-createLocation`;
    this.logger.logRepositoryRequest('LocationManagementAdapter', 'createLocation', { functionName, data });
    
    try {
      const createLocationFn = httpsCallable(functions, functionName);
      const result = await createLocationFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('LocationManagementAdapter', 'createLocation', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('LocationManagementAdapter', 'createLocation', duration, error);
      console.error('Create location error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }

  async updateLocation(data: UpdateLocationData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-updateLocation`;
    this.logger.logRepositoryRequest('LocationManagementAdapter', 'updateLocation', { functionName, data });
    
    try {
      const updateLocationFn = httpsCallable(functions, functionName);
      const result = await updateLocationFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('LocationManagementAdapter', 'updateLocation', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('LocationManagementAdapter', 'updateLocation', duration, error);
      console.error('Update location error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }
}